import { fullExpiryYear } from '../../shared/payment-method-form.js';
import { checkoutIntentFor, clearCheckoutIntent } from '../../shared/checkout-intent.js';
import { showAlertMsg } from '../show-alert-msg';
import { getManagerOverlayElement, getMemberOverlayElement, hideOverlay, showOverlay } from '../../shared/overlay.js';
import { opCfg, opIsMemberSession, opMinAmount, opGatewayApiForId } from './config.js';
import { opModal, openPaymentIsOnline } from './dom.js';
import { getOpenPaymentDafCardType } from './daf-card-type.js';
import { fetchOpenPaymentNonce } from './nonce.js';
import { openPaymentValidateCardForm } from './validation.js';
import { showOpenPaymentAjaxMsg, hideOpenPaymentAjaxMsg, closeOpenPaymentModal, tryLockOpenPaymentSubmit, unlockOpenPaymentSubmit } from './ui-state.js';

export function parseAmount(raw) {
    const trimmed = String(raw || '').replace(/,/g, '').trim();
    if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
        return NaN;
    }
    return parseFloat(trimmed);
}

function openPaymentBusyOverlay() {
    return opIsMemberSession() ? getMemberOverlayElement() : getManagerOverlayElement();
}

function showOpenPaymentBusyOverlay() {
    showOverlay(openPaymentBusyOverlay(), { immediate: true });
}

function hideOpenPaymentBusyOverlay() {
    hideOverlay(openPaymentBusyOverlay(), { immediate: true });
}

function buildGatewayAmountEntries(amounts) {
    const entries = [];
    Object.keys(amounts).forEach(function (gatewayIdStr) {
        const gatewayId = parseInt(gatewayIdStr, 10);
        if (!Number.isFinite(gatewayId) || gatewayId <= 0) {
            return;
        }
        const rawAmount = amounts[gatewayIdStr];
        entries.push({
            gatewayId: gatewayId,
            amount: Number(Number(rawAmount).toFixed(2)),
        });
    });
    return entries;
}

export function bindOpenPaymentAddModalSubmitHandler() {
    $(document).off('submit.openPayAddForm', '#validOpenPayment');
    $(document).on('submit.openPayAddForm', '#validOpenPayment', function (e) {
        e.preventDefault();
        if (!tryLockOpenPaymentSubmit()) {
            return false;
        }

        let requestStarted = false;
        try {
            return runOpenPaymentSubmit(function markRequestStarted() {
                requestStarted = true;
            });
        } finally {
            if (!requestStarted) {
                unlockOpenPaymentSubmit();
            }
        }
    });
}

function collectOpenPaymentRequest() {
    const postUrl = String(opCfg().postUrl || '');
    const csrfToken = String(opCfg().csrfToken || '');
    const minAmount = opMinAmount();

    if (!postUrl) {
        showOpenPaymentAjaxMsg('alert-danger', '<li>Payment API is not configured.</li>');
        return null;
    }

    hideOpenPaymentAjaxMsg();
    const online = openPaymentIsOnline();
    const uid = opModal().find('#open_payment_user_id').val();
    if (!uid) {
        showOpenPaymentAjaxMsg('alert-danger', '<li>Please select a member.</li>');
        return null;
    }
    const paymentDate = String(opModal().find('#open_payment_date').val() || '').trim();
    if (!paymentDate) {
        showOpenPaymentAjaxMsg('alert-danger', '<li>Please select a payment date.</li>');
        return null;
    }

    const $amountInputs = opModal().find('.open-payment-amount-input');
    const amounts = {};
    let any = false;
    let hasInvalid = false;

    $amountInputs.each(function () {
        const $inp = $(this);
        const gid = parseInt(String($inp.data('gateway-id') || '0'), 10);
        const title = String($inp.data('gateway-title') || '').trim();
        const val = parseAmount($inp.val());

        if (!gid) {
            return;
        }
        if ($inp.val() === '' || $inp.val() === null || typeof $inp.val() === 'undefined') {
            return;
        }
        if (!Number.isFinite(val) || val < 0) {
            hasInvalid = true;
            return;
        }
        if (val === 0) {
            return;
        }
        if (val < minAmount) {
            hasInvalid = true;
            const label = title ? String(title).replace(/</g, '&lt;').replace(/>/g, '&gt;') : 'a gateway';
            showOpenPaymentAjaxMsg('alert-danger', '<li>The minimum amount for ' + label + ' is $' + minAmount.toFixed(2) + '.</li>');
            return false;
        }

        any = true;
        amounts[String(gid)] = val;
    });

    if (hasInvalid) {
        if (opModal().find('#ajaxMsgOpenPayment').hasClass('d-none')) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Please enter valid amounts.</li>');
        }
        return null;
    }
    if (!any) {
        showOpenPaymentAjaxMsg('alert-danger', '<li>Please enter at least one amount.</li>');
        return null;
    }

    const $modal = opModal();
    return {
        postUrl,
        online,
        amounts,
        basePayload: {
            user_id: uid,
            amounts: amounts,
            payment_date: paymentDate,
            description: $modal.find('#open_payment_description').val(),
            open_payment_method: online ? 'online' : 'check_cash',
            offline_payment_notes: $modal.find('#open_payment_description').val(),
            checkout_intent: checkoutIntentFor($modal),
            _token: csrfToken,
        },
    };
}

function postOpenPayment(request, extra) {
    return $.post(request.postUrl, Object.assign({}, request.basePayload, extra));
}

function finishOpenPaymentPost(promise) {
    promise
        .done(function (res) {
            hideOpenPaymentBusyOverlay();
            if (res.success) {
                clearCheckoutIntent(opModal());
                showAlertMsg('Payment processed successfully.');
                closeOpenPaymentModal({ action: 'submit' });
            } else {
                unlockOpenPaymentSubmit();
                showOpenPaymentAjaxMsg('alert-danger', '<li>' + (res.error || 'Payment failed.') + '</li>');
            }
        })
        .fail(function (xhr) {
            hideOpenPaymentBusyOverlay();
            unlockOpenPaymentSubmit();
            const err = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Request failed.';
            showOpenPaymentAjaxMsg('alert-danger', '<li>' + err + '</li>');
        });
}

export function submitOpenPaymentSwipe(swipeResult, gatewayId) {
    if (!tryLockOpenPaymentSubmit()) {
        return;
    }
    const request = collectOpenPaymentRequest();
    if (!request) {
        unlockOpenPaymentSubmit();
        return;
    }
    const amountGatewayIds = Object.keys(request.amounts);
    if (amountGatewayIds.length !== 1 || amountGatewayIds[0] !== String(gatewayId)) {
        unlockOpenPaymentSubmit();
        showOpenPaymentAjaxMsg('alert-danger', '<li>Swipe supports one account at a time. Enter an amount for a single account.</li>');
        return;
    }
    if (!swipeResult.nonce) {
        unlockOpenPaymentSubmit();
        showOpenPaymentAjaxMsg('alert-danger', '<li>The swiped card could not be read. Please try again.</li>');
        return;
    }

    const p = '#open_payment_';
    const coverSurcharge = opModal().find(p + 'cover_surcharge_manual').prop('checked') ? 'true' : 'false';
    showOpenPaymentBusyOverlay();
    finishOpenPaymentPost(postOpenPayment(request, {
        payment_type: 'new',
        process_type: 'nonce',
        type: 'swipe',
        is_swipe: true,
        nonces: { [String(gatewayId)]: swipeResult.nonce },
        name: swipeResult.name,
        maskedCard: swipeResult.maskedCard,
        cardType: swipeResult.cardType,
        last4: swipeResult.last4,
        expiryMonth: swipeResult.expiryMonth,
        expiryYear: swipeResult.expiryYear,
        cover_surcharge: coverSurcharge,
        cover_surcharge_manual: coverSurcharge,
        save_card: !!opModal().find(p + 'save_card').prop('checked'),
    }));
}

function runOpenPaymentSubmit(markRequestStarted) {
        const tokenUrl = String(opCfg().tokenUrl || '');
        const request = collectOpenPaymentRequest();
        if (!request) {
            return false;
        }
        const { postUrl: openPaymentPostUrl, online, amounts, basePayload } = request;
        const $modal = opModal();

        if (!online) {
            markRequestStarted();
            showOpenPaymentBusyOverlay();
            $.post(openPaymentPostUrl, basePayload)
                .done(function (res) {
                    hideOpenPaymentBusyOverlay();
                    if (res.success) {
                        clearCheckoutIntent($modal);
                        showAlertMsg(res.msg || 'Open credit recorded.');
                        closeOpenPaymentModal({ action: 'submit' });
                    } else {
                        unlockOpenPaymentSubmit();
                        showOpenPaymentAjaxMsg('alert-danger', '<li>' + (res.error || 'Unable to save.') + '</li>');
                    }
                })
                .fail(function (xhr) {
                    hideOpenPaymentBusyOverlay();
                    unlockOpenPaymentSubmit();
                    const err = xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : 'Request failed.';
                    showOpenPaymentAjaxMsg('alert-danger', '<li>' + err + '</li>');
                });
            return false;
        }

        const p = '#open_payment_';
        const ptype = opModal().find(p + 'payment_type').val();
        if (!ptype) {
            showOpenPaymentAjaxMsg('alert-danger', '<li>Choose saved card or new card.</li>');
            return false;
        }
        if (ptype === 'new' && !openPaymentValidateCardForm()) {
            return false;
        }

        showOpenPaymentBusyOverlay();

        const coverSaved = opModal().find(p + 'cover_surcharge_saved').prop('checked');
        const coverManual = opModal().find(p + 'cover_surcharge_manual').prop('checked');
        const saveCard = !!opModal().find(p + 'save_card').prop('checked');
        const useOtp = !!opModal().find(p + 'use_otp').prop('checked');

        if (ptype === 'saved') {
            const ccId = opModal().find(p + 'saved_payment_id').val();
            if (!ccId) {
                hideOpenPaymentBusyOverlay();
                showOpenPaymentAjaxMsg('alert-danger', '<li>Select a saved card.</li>');
                return false;
            }
            markRequestStarted();
            finishOpenPaymentPost(postOpenPayment(request, {
                payment_type: 'saved',
                process_type: 'token',
                cc_id: ccId,
                cover_surcharge: coverSaved ? 'true' : 'false',
                cover_surcharge_saved: coverSaved ? 'true' : 'false',
            }));
            return false;
        }

        const dafCardType = getOpenPaymentDafCardType();
        const ccPayload = {
            payment_type: 'new',
            name: opModal().find(p + 'name').val(),
            maskedCard: opModal().find(p + 'card').val().slice(-4),
            expiryMonth: opModal().find(p + 'expiry_month').val(),
            expiryYear: fullExpiryYear(opModal().find(p + 'expiry_year').val()),
            cvv2: opModal().find(p + 'cvv2').val(),
            avs_zip: opModal().find(p + 'avs_zip').val(),
            use_otp: useOtp,
            cover_surcharge: coverManual ? 'true' : 'false',
            cover_surcharge_manual: coverManual ? 'true' : 'false',
            save_card: saveCard,
            daf_card_type: dafCardType,
        };

        const gatewayAmountEntries = buildGatewayAmountEntries(amounts);
        const tokenizeBody = {
            card: opModal().find(p + 'card').val().replace(/ /g, ''),
            cvv2: opModal().find(p + 'cvv2').val().replace(/_/g, ''),
        };

        if (dafCardType === 'credit') {
            markRequestStarted();
            Promise.all(
                gatewayAmountEntries.map(function ({ gatewayId }) {
                    return fetchOpenPaymentNonce(
                        tokenUrl,
                        opGatewayApiForId(gatewayId),
                        tokenizeBody
                    ).then(function (tokenResult) {
                        if (!tokenResult.ok) {
                            throw new Error(tokenResult.error);
                        }

                        return [String(gatewayId), tokenResult.nonce];
                    });
                })
            )
                .then(function (tokenResults) {
                    finishOpenPaymentPost(
                        postOpenPayment(request, Object.assign({}, ccPayload, {
                            process_type: 'nonce',
                            nonces: Object.fromEntries(tokenResults),
                        }))
                    );
                })
                .catch(function (err) {
                    hideOpenPaymentBusyOverlay();
                    unlockOpenPaymentSubmit();
                    showOpenPaymentAjaxMsg(
                        'alert-danger',
                        '<li>' + (err.message || 'Could not tokenize card.') + '</li>'
                    );
                });
        } else {
            markRequestStarted();
            finishOpenPaymentPost(postOpenPayment(request, Object.assign({}, ccPayload, {
                process_type: 'direct',
                nonce: '',
                daf_card: opModal().find(p + 'card').val().replace(/ /g, ''),
            })));
        }

        return false;
}
